module.exports = __webpack_public_path__ + "static/media/ImgNovedades220906_2.3664e9d4.jpg";